import * as React from 'react'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { DateAndTime, Order } from 'orders/schema'
import { convertTimeFormat, DateFormats, formatISOString } from 'utils/dates'
import { useTranslation } from 'translations'

interface UpdateDialogProps {
    dialogType: 'visitDate' | 'visitTime'
    order?: Order
    updatedDateTime: DateAndTime
    onCancel: () => void
    onConfirm: () => void
}

export function UpdateDialog(props: UpdateDialogProps) {
    const { t } = useTranslation()
    const title =
        props.dialogType === 'visitDate'
            ? t('orders.transactions.updateDialog.visitDateTitle')
            : t('orders.transactions.updateDialog.visitTimeTitle')
    const orderDate =
        props.order && props.order.visitDate
            ? formatISOString(props.order.visitDate, DateFormats.EXTRA_LONG_DATE)
            : t('orders.transactions.updateDialog.theDate')
    const orderTime = props.order && props.order.visitTime ? convertTimeFormat(props.order.visitTime) : ''
    const date = props.updatedDateTime.date
        ? formatISOString(props.updatedDateTime.date, DateFormats.EXTRA_LONG_DATE)
        : orderDate
    const time = props.updatedDateTime.time ? convertTimeFormat(props.updatedDateTime.time) : orderTime
    const text = time
        ? t('orders.transactions.updateDialog.availabilityOnDateTime', { date, time })
        : t('orders.transactions.updateDialog.availabilityOnDate', { date })

    return (
        <ConfirmationDialog
            title={title}
            text={text}
            buttonText={t('orders.transactions.updateDialog.confirm')}
            onCancel={props.onCancel}
            onConfirm={props.onConfirm}
        />
    )
}
